import { generateOfferPageRoom, type OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { resolveFlashPackageSelection, setFlashPackageQuantity } from './flashPackageSelection'

type Options = Parameters<typeof setFlashPackageQuantity>[0] & { offerId: string; addingPackage: boolean }

/** Keep committed choices untouched until the existing occupancy picker applies the draft. */
export function createFlashPackageQuantityDraft({ offerId, addingPackage, ...options }: Options): OfferPageState['flashQuantityDraft'] {
  const { rooms, packageView, quantity, viewsByOccupancy, requiresRates, checkInventory } = options
  if (!Number.isInteger(quantity) || quantity < 1) return undefined
  const result = setFlashPackageQuantity({ ...options, quantity: 1 })
  if (!result.ok) return undefined
  const firstRoom = result.rooms[0]
  const nextRooms = addingPackage
    ? [...rooms, ...Array.from({ length: quantity }, () => generateOfferPageRoom({ ...firstRoom, id: undefined }))]
    : [firstRoom, ...Array.from({ length: quantity - 1 }, () => generateOfferPageRoom({ ...firstRoom, id: undefined }))]
  const draftViews = Object.fromEntries(nextRooms.map(room => [room.id, viewsByOccupancy[rooms[0].id]]))
  if (!resolveFlashPackageSelection({ rooms: nextRooms, viewsByOccupancy: draftViews, requiresRates, checkInventory }).complete) return undefined
  return {
    rooms: nextRooms,
    selection: { offerId, packageKey: packageView.package.uniqueKey },
    multiRoomMode: addingPackage ? 'individual' : 'same-room',
  }
}
